import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=df8b133c&scoped=true"
import script from "./footer-info.vue?vue&type=script&lang=js"
export * from "./footer-info.vue?vue&type=script&lang=js"
import style0 from "./footer-info.vue?vue&type=style&index=0&id=df8b133c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8b133c",
  null
  
)

export default component.exports